import { Injectable } from '@angular/core';
import { BehaviorSubject } from "rxjs";

@Injectable({ providedIn: 'root' })
export class LoaderService {
  loading = new BehaviorSubject<boolean>(false);
  showSpinner = new BehaviorSubject<boolean>(true);
  consoleOutputEnabled = false;

  startLoading(showSpinner: boolean = true): void {
    if (this.consoleOutputEnabled) console.log("LoaderService.startLoading");
    this.showSpinner.next(showSpinner);
    this.loading.next(true);
  }

  dismissLoading(): void {
    if (this.consoleOutputEnabled) console.log("LoaderService.dismissLoading");
    this.showSpinner.next(true);
    this.loading.next(false);
  }
}
